import { FilterDropdown } from "Components/Shared/Components/FilterDropdown";
import { CardTransactionStatus } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const PageResources = Resources.Components.Shared.Filters;
const StatusResources = Resources.Components.CardTransactions.Status;

type Props = {
  value?: CardTransactionStatus;
  onChange: (value: CardTransactionStatus | undefined) => void;
};

export const CardStatusFilterDropdown = ({ value, onChange }: Props) => {
  const { t } = useResource();

  const statusOptions = [
    { value: "", label: t(PageResources.AllStatuses) },
    {
      value: CardTransactionStatus.Approved,
      label: t(StatusResources[CardTransactionStatus.Approved]),
    },
    {
      value: CardTransactionStatus.Rejected,
      label: t(StatusResources[CardTransactionStatus.Rejected]),
    },
    {
      value: CardTransactionStatus.Canceled,
      label: t(StatusResources[CardTransactionStatus.Canceled]),
    },
    {
      value: CardTransactionStatus.Pending,
      label: t(StatusResources[CardTransactionStatus.Pending]),
    },
    {
      value: CardTransactionStatus.Unknown,
      label: t(StatusResources[CardTransactionStatus.Unknown]),
    },
  ];

  const handleChange = (newValue: string | number) => {
    onChange(newValue === "" ? undefined : (newValue as CardTransactionStatus));
  };

  return (
    <FilterDropdown
      label={t(PageResources.Status)}
      options={statusOptions}
      value={value ?? ""}
      onChange={handleChange}
      placeholder={t(PageResources.AllStatuses)}
    />
  );
};
